import Axios from 'axios';
import store from '@/store';

const instance = Axios.create({
	baseURL: process.env.VUE_APP_BACKEND_URL
});

instance.interceptors.request.use(async config => {
	const accessToken = localStorage.getItem('accessToken');

	if (accessToken !== null && accessToken !== '') {
		config.headers.Authorization = `Bearer ${accessToken}`;
	}

	return config;
});

// let tokenPromise; // token refresh requests

instance.interceptors.response.use(response => {
	return response;
}, async function (error) {
	// If error is not auth related
	if (error.response.status !== 401) {
		return Promise.reject(error);
	}
	return Promise.reject(store.dispatch('logout', 'Your session has expired. Please log in again.'));
});

export default instance;
